/**
 * @generated SignedSource<<e4f14c965a104436f1264c97a8c64f73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteListItemMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type DeleteListItemMutation$data = {
  readonly deleteListItem: string | null | undefined;
};
export type DeleteListItemMutation = {
  response: DeleteListItemMutation$data;
  variables: DeleteListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "deleteListItem",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteListItemMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteListItemMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteListItem",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ad0520d19d038f6c45a887ee4288c861",
    "id": null,
    "metadata": {},
    "name": "DeleteListItemMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteListItemMutation(\n  $id: ID!\n) {\n  deleteListItem(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "1673318196ce2365521f8888ac9a7297";

export default node;
